'use client'

import { useNavContext } from './nav-context-provider'
import { NavCtaButton } from './nav-cta-button'
import { Close, Toggler } from './nav-topbar'

export const NavMobileHamburger: React.FC = () => {
  const navContext = useNavContext()

  const active = navContext.isMobileMenuVisible || (navContext.isMobile && navContext.current.containerId)
  return (
    <section className="search--mobile flex gap-2 nav:hidden">
      <NavCtaButton />
      {active ? (
        <Close
          data-nav-mobile-trigger
          aria-expanded={true}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            navContext.clear()
            navContext.setMobileMenuVisible(false)
          }}
        />
      ) : (
        <Toggler
          data-nav-mobile-trigger
          aria-expanded={false}
          onClick={(e: React.MouseEvent) => {
            e.preventDefault()
            navContext.clear()
            navContext.setMobileMenuVisible(true)
          }}
        />
      )}
    </section>
  )
}
